import { render, staticRenderFns } from "./mobileContent4.vue?vue&type=template&id=678d0fe8&scoped=true"
import script from "./mobileContent4.vue?vue&type=script&lang=js"
export * from "./mobileContent4.vue?vue&type=script&lang=js"
import style0 from "./mobileContent4.vue?vue&type=style&index=0&id=678d0fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d0fe8",
  null
  
)

export default component.exports